import request from "@/utils/request";

/**
 * 更新采集
 * https://yapi.gaoding.com/project/1536/interface/api/116219
 * @param pin_id {number}
 * @param board_id {number}
 * @param text {string}
 * @param link {string|undefined}
 * @param tags {number[]}
 * @returns {AxiosPromise}
 */
export function getCategoriesWithCover() {
  return request({
    url: `/categories`,
  });
}
